import { Directive, ElementRef, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[portalSetLanguageCssClass]',
  standalone: false,
})
export class LangCssClassDirective implements OnInit {
  private readonly el = inject<ElementRef<HTMLDivElement>>(ElementRef);
  private readonly translateService = inject(TranslateService);

  ngOnInit(): void {
    const lang = this.translateService.currentLang || this.translateService.getDefaultLang();
    this.el.nativeElement.classList.add(lang?.toLowerCase());
  }
}
